export default "__VITE_PUBLIC_ASSET__8ad1c776__"